<app-card-layout-content class="unconfirmed-account-page">
  <app-card-layout-content-header [noLogo]="true">
    <app-card-layout-content-image>
      <app-unconfirmed-account-svg-icon></app-unconfirmed-account-svg-icon>
    </app-card-layout-content-image>
    <app-card-layout-content-title>
      <h1 i18n>Account in attesa di conferma</h1>
    </app-card-layout-content-title>
    <app-card-layout-content-description>
      <div class="p-d-flex p-flex-column p-text-center p-mb-5">
        <span i18n>Ciao!</span>
        <span i18n>La tua registrazione è quasi completata.</span>
        <span class="p-mt-4" i18n
          >Verifica il tuo numero di telefono per iniziare ad usare tutti i servizi <strong>{{ brandName }}</strong
          >.</span
        >
      </div>
    </app-card-layout-content-description>
  </app-card-layout-content-header>
  <div class="p-mt-auto">
    <div class="p-d-flex p-flex-column p-ai-center p-mb-3">
      <span i18n>Hai bisogno di aiuto?</span>
      <a class="p-mt-1 p-text-bold" [href]="'tel:' + helplineNumber" i18n>Contatta l’assistenza</a>
    </div>
    <a
      class="unconfirmed-account-page__link p-button"
      [routerLink]="confirmMobilePath"
      [state]="pendingData"
      [queryParamsHandling]="'merge'"
      i18n="UnconfirmedAccount|Label completa la registrazione"
      >Completa la registrazione</a
    >
  </div>
</app-card-layout-content>
